import { inject, Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
    providedIn: "root",
})
export class ToastService {
    TOAST_KEY: string = "global-toast";
    STICKY: boolean = false;
    LIFE: number = 8000;

    private readonly msgService = inject(MessageService);

    async showSuccessToast(summary: string, detail: string): Promise<void> {
        this.showToast(summary, detail, "success");
    }

    async showInfoToast(summary: string, detail: string): Promise<void> {
        this.showToast(summary, detail, "info");
    }

    async showWarnToast(summary: string, detail: string): Promise<void> {
        this.showToast(summary, detail, "warn");
    }

    async showErrorToast(summary: string, detail: string): Promise<void> {
        this.showToast(summary, detail, "error");
    }

    private showToast(summary: string, detail: string, severity: string): void {
        this.msgService.add({
            key: this.TOAST_KEY,
            severity: severity,
            summary: summary,
            detail: detail,
            sticky: this.STICKY,
            life: this.LIFE,
        });
    }
}
